// libraries
import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';

import reducers from '../reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(preloadedState = {}, routerMiddleware) {
  return createStore(
    reducers,
    preloadedState,
    composeEnhancers(
      applyMiddleware(routerMiddleware, thunkMiddleware)
    )
  );
}
